export const TABLET_BREAKPOINT = 576;
export const DESKTOP_BREAKPOINT = 992;

export const MOBILE_COLS = 2;
export const TABLET_COLS = 3;
export const DESKTOP_COLS = 5;

export const PRODUCTO_LINEA = "productoLinea";
export const PRODUCTO_ESPECIAL = "productoEspecial";

export const ROLES_PGI = ["owner", "author"];
export const ROLES_CLIENTES = ["Usuario"];

export const PDFtype = "application/pdf";
export const URLDefaultLogoTensolite = "https://tensolite.com/images/redes.png";

export const allowedCountryCodes = [55, 56, 591, 1, 57, 52, 51, 595, 598, 58, 593, 503, 506, 507];

export const charCodes = {
  charCodeBackspace: 8,
  charCodeZero: 48,
  charCodeNine: 57
}

export const objectField = {
  visibleField: 'visible',
  slideNewsField: 'slideNews'
}

export const firstPage = 1;
export const tenPagesPerPage = 10;
export const allCategories = 'all';
export const getSlideNewsTrue = true;
export const getSlideNewsFalse = false;
export const multimediaNews = true;
export const multimediaNewsFalse = false;
export const allSlideNews = null;
export const allProducts = null;
export const newsPublished = true;
export const allVisibleNews = null;
export const sortBySlideNews = true;

export const getOnlyTenNewsParams = [firstPage, tenPagesPerPage, allCategories, getSlideNewsTrue];
export const getOnlyTenNewsHomeParams = [firstPage, tenPagesPerPage, allCategories];
export const getOnlyTenMultimediaNewsByCategory = (videoCategory) => {
  return [firstPage, tenPagesPerPage, videoCategory, getSlideNewsFalse]
}
export const getMultimediaNews = [firstPage, tenPagesPerPage, allCategories, getSlideNewsFalse, multimediaNews];
export const getNewsByProduct = (product) => {
  return [firstPage, tenPagesPerPage, allCategories, getSlideNewsFalse, multimediaNewsFalse, product]
}

export const messageArticleSuccess = 'Articulo actualizado con exito';

export const articleName = 'article';

export const titleRegex = /^[a-zA-ZÀ-ÿ\s\d_!$%&+,.:;=?@[\]^`{|}~]+$/;

export const models3DNames = {
  Pasarelas: 'pasarelas',
  Vigas: 'vigas',
  Estructuras: 'estructuras',
  Tribunas: 'tribunas'
}

export const firstOpcionOfSelect = 0;

export const holcimWebPage = 'https://www.holcim.com.ar/';

export const pgiPath = '/pgi';